import { atom } from 'jotai';
import { createRequestAtom } from '../../../../../../shared/utils/request-atom';
import { AddonGetTrialApiResponse, AddonPostTrialApiResponse, FreeTrialStep } from '../typings';

/** Single source of truth: current step of the free trial flow, or Closed when no modal is shown. */
export const freeTrialStepAtom = atom<FreeTrialStep>(FreeTrialStep.Closed);

export const trialDetailsAtom = createRequestAtom<AddonGetTrialApiResponse>();

export const startTrialAtom = createRequestAtom<AddonPostTrialApiResponse>({ initialLoading: false });
